import React from "react";
import { VisionCard } from "./VisionCard";
import styled from "styled-components";

const VisionBoard = ({ board, onCardClick, onDeleteCard, isOwner }) => {
  return (
    <BoardContainer>
      <Grid>
        {board.map((card) => (
          <VisionCard
            key={card.docId}
            card={card}
            onClick={() => onCardClick(card)}
            onDelete={() => onDeleteCard(card.docId)}
            isOwner={isOwner}
          />
        ))}
      </Grid>
    </BoardContainer>
  );
};

const BoardContainer = styled.main`
  flex: 1;
  padding: 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  padding: 1rem;
`;

export { VisionBoard };
